const clientSettingsQueryKeys = {
  all: ["client-settings"] as const,
  category: (userId: string, category?: string) =>
    [...clientSettingsQueryKeys.all, userId, category] as const,
};

export default clientSettingsQueryKeys;
